import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAllEmployees } from "../../services/employeeService";
export const fetchEmployeeList = createAsyncThunk(
  "employee/list",
  async (id, { rejectWithValue }) => {
    try {
      //TODO: add loggedInUserId

      let result = await fetchAllEmployees();
      return result;
    } catch (error) {
        return rejectWithValue({
            status: error.state,
            message: error?.message || "Something went wrong at Server Side"
        })
    }
  }
);

const initialValue = {
  employeeList: null,
  employeeListLoading: false,
  error: null,
  noAccess: null,
  errorCode: null,
};

const employeeListSlice = createSlice({
  name: "employeeList",
  initialState: initialValue,
  reducers: {
    clearEmployeesData: (state) => {
      state.employeeList = null;
      state.employeeListLoading = false;
      state.error = null;
      state.noAccess = false;
      state.errorCode = null;
    },
    setEmployeeDetails: (state, action) => {
      if (action?.payload) {
        // TODO:store the data locally
        // const project = action?.payload;
      }
    },
    updateAccessStatus: (state, action) => {
      state.noAccess = action.payload.noAccess;
      state.errorCode = action.payload.errorCode;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeList.pending, (state) => {
          state.employeeListLoading = true;
          state.error = null;
          state.errorCode = null;
      })
      .addCase(fetchEmployeeList.fulfilled, (state, action) => {
        state.employeeListLoading = false;
        state.employeeList = action.payload;
        state.error = null;
        state.noAccess = false;
      })
      .addCase(fetchEmployeeList.rejected, (state, action) => {
        state.employeeListLoading = false;
        state.error = action.payload || {
          message: "An unknown error occurred",
        };
      });
  },
});

export const {clearEmployeesData,setEmployeeDetails} = employeeListSlice.actions;
export default employeeListSlice.reducer;
